import axios from 'axios'
import { AUTH_URL, GET_SECTIONS_URL, USERMEETING_DETAIL_URL, CHANGE_USERMEETING_URL } from '../../../vars'
import {errorHelper} from '../helper'

/**
 * @namespace Registration
 */
export default {
    state: {
        sections: []
    },
    mutations: {
        UPDATE_SECTIONS(state, sections) {
            // console.log('EEEE', sections);
            state.sections = sections;
        },
    },

    actions: {
        /**
         * Регистрирует новго пользователя в системе
         * @param {Object} ctx 
         * @param {Object} data Данные регистрации
         * @returns {Object} Резьтат авторизации
         * @throws {Object} Ошибка запроса данных
         * 
         * @memberof Registration 
         */
       async REGISTRATION(ctx, data) {
            try {
                const res = await axios.post(`${AUTH_URL}register/`, data);
                return res
            } catch(e) {
                console.log(e)
                throw e
            }
       },

       async GET_SECTIONS(ctx, id) {
        try {
          const res = await axios.get(`${GET_SECTIONS_URL}?id=${id}`, {
            headers: {
              Authorization: `Token ${localStorage.token}`,
            },
          });
 
          await ctx.commit('UPDATE_SECTIONS', res.data);
        } catch (e) {
          errorHelper(e);
          messageHelper('', 'error', 6000, e);
          throw e;
        }
      },

                /**
         * Получает детальную информацию и записывает
         * @param {Object} ctx
         * @param {String|Number} id Идентификатор
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async GET_USER_ALL(ctx, id) {
            try {
            const res = await axios.get(`${USERMEETING_DETAIL_URL}?id=${id}`, {
                headers: {
                Authorization: `Token ${localStorage.token}`,
                },
            });
            return res.data
            } catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log(e, ' GET_USER_ALL');
                throw e;
            }
        },

        async CHANGE_USERMEETING(ctx, data) {
            try {
                const res = await axios.post(`${CHANGE_USERMEETING_URL}`, data, {
                    headers: {
                      Authorization: `Token ${localStorage.token}`
                    }
                  });
                return res
            } catch(e) {
                console.log(e)
                throw e
            }
        },

    },

    getters: {
        GETTERS_SECTIONS(state) {
            return state.sections;
          },
      
    },
}